/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { NewsState } from './types';
import { RootState } from '../types';

export const state: NewsState = {
  newsList: {
    error: undefined,
    data: [],
    status: undefined,
  },
  news: {
    error: undefined,
    data: undefined,
    status: undefined,
  },
};

const namespaced = true;

export const news: Module<NewsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
